<script>
  import loginServico from './servico';

  export default {
    data() {
      return {
        usuario: {},
        mostrarErroUsuario: false, 
        configuracao: this.$storage.configuracao(),
      }
    },
    methods: {
      validar: function () {
        this.$validator.validateAll();

        if (!this.errors.any()) {
          this.login()
        }
      },
      login: function () {
        this.mostrarErroUsuario = false;
        
        $('.btn').button('loading');

        loginServico.funcionario(this.usuario)
          .then(resposta => {
            this.$storage.usuario(resposta.body.usuario);
            this.$storage.token(resposta.body.token);
          })
          .then(() => {
            this.$router.push('/');
          })
          .catch(erro => {
            $('.btn').button('reset');
            
            if (erro.status === 404) {
              this.mostrarErroUsuario = true;
            } else {
              this.$swal('', 'Ocorreu um erro no login, caso o erro persista entre em contato com a fundação.', 'error');
            }
          });
      }
    }
  }
</script>

<template>
  <div>
    <form class="m-t" role="form" @submit.prevent="validar">
      <div class="alert alert-danger" role="alert" v-show="mostrarErroUsuario">CPF ou senha incorreto(s).</div>

      <div class="form-group" :class="{ 'has-error': errors.has('CPF') }">
        <input type="text"
               class="form-control"
               placeholder="CPF"
               name="CPF"
               id="cpf"
               v-model="usuario.login"
               v-validate="'required'"
               v-mascara="'cpf'">

        <p class="text-danger" v-if="errors.has('CPF')">{{ errors.first('CPF') }}</p>
      </div>
      <div class="form-group" :class="{ 'has-error': errors.has('senha') }">
        <input type="password"
               class="form-control"
               placeholder="*******"
               name="senha"
               v-model="usuario.senha"
               v-validate="'required'">

        <p class="text-danger" v-if="errors.has('senha')">{{ errors.first('senha') }}</p>
      </div>
      <button type="submit"
              class="btn btn-primary block full-width m-b"
              data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Entrando...">
        Entrar
      </button>
    </form>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/login/LoginFuncionario.vue